/* STEP 11b Part 1 · lane P1B (owner card 31-Oct-2026 12:41 KSA) — EN + AR of
   * item 8a: Founder → Diagnostics → Backups → "Stop backup" (s11b.backups);
   * item 8c: Founder → Alerts → the monthly restore check switch (s11b.restoreAuto) and two Alerts history kinds;
   * the coded refusal BACKUP_NOT_RUNNING (errors). No provider or vendor name. */
export const I18N_S11B_P1B = {
  en: {
    s11b: {
      backups: {
        stop: "Stop backup",
        stopAsk: "Stop the running backup? The upload in progress is aborted and this run is never used; the last finished backup stays.",
        stopYes: "Yes, stop it",
        stopNo: "Cancel",
        stopSent: "Stop sent by {by}: {running} running backup(s) stop at their next heartbeat (within 30 seconds); {queued} queued backup(s) stopped.",
        stopFailed: "The backup was not stopped",
        stopping: "Stopping — asked by {name}",
        stoppedBy: "stopped by {name}",
      },
      restoreAuto: {
        title: "Monthly restore check",
        about: "Automatic: the first Saturday of each month at 07:00 KSA (after the 05:30 backup) — the platform database first, then each firm, one at a time, on its latest backup. Passed: a line in the 08:00 KSA digest. Failed: an alert. The 35-day reminder stays.",
        switch: "Run it automatically",
        on: "On",
        off: "Off — no automatic check (the 35-day reminder still runs)",
        next: "Next run",
        last: "Last run",
        never: "not run yet",
        passed: "passed ({n} of {n} scopes)",
        failed: "{failed} of {n} scopes failed",
        running: "running ({checked} of {n} scopes)",
        saved: "Monthly restore check: {state}",
        saveError: "Could not save",
      },
    },
    s10e: { alerts: { kind: { restore_check_passed: "Monthly restore check passed", restore_check_skipped: "Monthly restore check skipped (off)" } } },
    errors: { BACKUP_NOT_RUNNING: "No backup is running — there is nothing to stop." },
  },
  ar: {
    s11b: {
      backups: {
        stop: "إيقاف النسخ الاحتياطي",
        stopAsk: "إيقاف النسخ الاحتياطي الجاري؟ يُلغى الرفع الجاري ولا يُستخدم هذا التشغيل أبداً؛ وتبقى آخر نسخة احتياطية مكتملة.",
        stopYes: "نعم، أوقفه",
        stopNo: "إلغاء",
        stopSent: "أرسل {by} أمر الإيقاف: يتوقف {running} نسخ احتياطي جارٍ عند نبضته التالية (خلال 30 ثانية)؛ وأُوقف {queued} نسخ احتياطي في الانتظار.",
        stopFailed: "لم يُوقف النسخ الاحتياطي",
        stopping: "جارٍ الإيقاف — بطلب من {name}",
        stoppedBy: "أوقفه {name}",
      },
      restoreAuto: {
        title: "فحص الاستعادة الشهري",
        about: "تلقائي: أول سبت من كل شهر الساعة 07:00 بتوقيت السعودية (بعد النسخ الاحتياطي الساعة 05:30) — قاعدة بيانات المنصة أولاً، ثم كل شركة، واحدة تلو الأخرى، على آخر نسخة احتياطية لها. عند النجاح: سطر في الملخص اليومي الساعة 08:00. عند الفشل: تنبيه. ويبقى تذكير الـ 35 يوماً.",
        switch: "تشغيله تلقائياً",
        on: "مفعّل",
        off: "مُطفأ — لا فحص تلقائي (ويبقى تذكير الـ 35 يوماً)",
        next: "التشغيل التالي",
        last: "آخر تشغيل",
        never: "لم يُشغَّل بعد",
        passed: "نجح ({n} من {n} نطاق)",
        failed: "فشل {failed} من {n} نطاق",
        running: "قيد التشغيل ({checked} من {n} نطاق)",
        saved: "فحص الاستعادة الشهري: {state}",
        saveError: "تعذّر الحفظ",
      },
    },
    s10e: { alerts: { kind: { restore_check_passed: "نجح فحص الاستعادة الشهري", restore_check_skipped: "تخطّي فحص الاستعادة الشهري (مُطفأ)" } } },
    errors: { BACKUP_NOT_RUNNING: "لا يوجد نسخ احتياطي قيد التشغيل — لا شيء لإيقافه." },
  },
};

export default I18N_S11B_P1B;
